import {
  fetchTransactionsAPI,
  FetchTransactionsAPIResult,
} from "../../../infrastructure/api/transactions";

/**
 * Fetch transactions for given account IDs and transaction type.
 *
 * @param accessToken - The authentication token.
 * @param accountIds - An object mapping each appUserId to an array of their account IDs.
 * @param transactionType - The type of transactions to fetch ("all", "Income", "Expense").
 * @param paginationOptions - Optional pagination and sorting options.
 * @returns A promise that resolves to the fetched transactions data.
 */
export const fetchTransactions = async (
  accessToken: string,
  accountIds: { [appUserId: string]: string[] },
  transactionType: string,
  paginationOptions: {
    limit: number | null;
    cursor: string | null;
    sortBy: string;
    sortOrder: string;
  } = {
    limit: null,
    cursor: null,
    sortBy: "date",
    sortOrder: "asc",
  },
): Promise<FetchTransactionsAPIResult> => {
  try {
    const params = {
      account_ids: accountIds, // Pass the object directly
      transaction_type: transactionType,
      limit: paginationOptions.limit,
      cursor: paginationOptions.cursor,
      sort_by: paginationOptions.sortBy,
      sort_order: paginationOptions.sortOrder,
    };
    return await fetchTransactionsAPI(accessToken, params);
  } catch (error) {
    console.error("Error fetching financial data:", error);
    throw error;
  }
};
